<template>
	<ul class="year_date_wrap">
        <li class="month_item" v-for="month in 12" @click="toMonth(month)">
            <h3 class="month_name">{{month}}月</h3>   
            <ul class="week_header">
                 <li class="h_item" v-for="wk in weekHeader">{{wk}}</li>
            </ul>
            <ul class="month_content">
                <li class="day_item" v-for="pre in getPreMonthDay(month)">
                    <!-- no_the_month 非本月 -->
                    <div class="day_num no_the_month">
                        <!-- planed 已计划 unplan 未计划 -->
                        <a class="day_tag">{{pre}}</a>
                    </div>
                </li>
                <li class="day_item" v-for="cur in currentMonthLastDay(month)">
                    <div class="day_num" v-if="holidayPlan&&holidayPlan.hasOwnProperty(year+'-'+month+'-'+cur)">
                        <!-- planed 已计划 unplan 未计划 -->
                            <a class="day_tag" :style="{'border':'1px solid '+getCurHolidayPlanBgColor(year+'-'+month+'-'+cur)}">{{cur}}</a>
                    </div>
                    <div class="day_num" v-else>
                        <a class="day_tag">{{cur}}</a>
                    </div>
                </li>
                <li class="day_item" v-for="next in getNextMonthDay(month)">
                     <div class="day_num no_the_month" >
                        <!-- planed 已计划 unplan 未计划 -->
                        <a class="day_tag">{{next}}</a>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
</template>
<script type="text/javascript">
import {
    mapGetters,
    mapActions
} from 'vuex'
export default{
	props:{
        year:null
	},
	data() {
        return { 
     	   weekHeader:["日","一","二","三","四","五","六"],
           allMonthDay:42,
        }
    },
    computed:{
        ...mapGetters({
            holidayPlan:'getHolidayPlan'
        }),
        getUrls(){
          console.log("agh",agho)
          let prefix='/AiGuanHuai/';
          let urlObj={}
          console.log("agho.urls",agho.urls)
          if(agho.urls){
              if(agho.urls.hasOwnProperty('agh/pop/birthdayTopic')){
                urlObj.birthdayTopic=agho.urls['agh/pop/birthdayTopic']
                if(urlObj.birthdayTopic.split('?')[1]){
                  urlObj.birthdayTopicParams=true;
                }
              }else{
                urlObj.birthdayTopic=prefix+'agh/pop/birthdayTopic'
              }
              if(agho.urls.hasOwnProperty('agh/pop/careDetail')){
                urlObj.careDetail=agho.urls['agh/pop/careDetail']
                if(urlObj.careDetail.split('?')[1]){
                  urlObj.careDetailParams=true;
                }
              }else{
                urlObj.careDetail=prefix+'agh/pop/careDetail'
              }
          }else{
            urlObj.birthdayTopic=prefix+'agh/birthdayTopic'
            urlObj.careDetail=prefix+'agh/pop/careDetail'
          }
          console.log('urlObj',urlObj)
          return urlObj;
        },
        getBirthdayTopicUrl(){
            return this.getUrls.birthdayTopicParams?this.getUrls.birthdayTopic+'&':this.getUrls.birthdayTopic+'?'
        },
        getCareDetailUrl(){
            return this.getUrls.careDetailParams?this.getUrls.careDetail+'&':this.getUrls.careDetail+'?'
        }
    },
    components:{
      
    },
    watch:{
        year(cval){
            let params={
                type:1,
                value:this.year
            }
            this.$store.dispatch('loadHolidayPlan',params)
        }
    },
    created(){
        let params={
            type:1,
            value:this.year
        }
        this.$store.dispatch('loadHolidayPlan',params)
    },
    methods:{
        getLastDay(year,month)        
        {        
         var new_year = year;    //取当前的年份        
         var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）        
         if(month>12)            //如果当前大于12月，则年份转到下一年        
         {        
          new_month -=12;        //月份减        
          new_year++;            //年份增        
         }        
         var new_date = new Date(new_year,new_month,1);                //取当年当月中的第一天        
         return (new Date(new_date.getTime()-1000*60*60*24)).getDate();//获取当月最后一天日期        
        },
        getLunarDay(year,month,day){
            return this.$calendar.solar2lunar(year,month,day).IDayCn;
        },
    	getPreMonthDay(month){
            let weekday=this.$calendar.solar2lunar(this.year,month,1).ncWeek;
            let spanDay=0;
            switch(weekday){
                case "星期日":
                spanDay=0;
                break;
                case "星期一":
                spanDay=1;
                break;
                case "星期二":
                spanDay=2;
                break;
                case "星期三":
                spanDay=3;
                break;
                case "星期四":
                spanDay=4;
                break;
                case "星期五":
                spanDay=5;
                break;
                case "星期六":
                spanDay=6;
                break;
            }
            console.log("allspanDay",weekday,spanDay)
            return spanDay;
        },
        preMonthLastDay(month){
            let lastDay=null;
           if(month==1){
                lastDay=this.getLastDay(this.year-1,12)
           }else{
                lastDay=this.getLastDay(this.year,month-1)
           }
           console.log('allpreMonthLastDay',lastDay)
           return lastDay;
        },
        currentMonthLastDay(month){
            return this.getLastDay(this.year,month);
        },
        getNextMonthDay(month){
            return this.allMonthDay-(this.getPreMonthDay(month)+this.currentMonthLastDay(month));
        },
        getCurHolidayPlanBgColor(key){
            console.log("getCurHolidayBgColor")
            if(this.holidayPlan&&this.holidayPlan.hasOwnProperty(key)){
                 return this.holidayPlan[key].bgColor;
            }else{
                return "transparent";
            }
           
        },
        toMonth(month){
            let params={};
            params.year=this.year;
            params.month=month;
            this.$emit('toggleMonth',params)
        }
    }
}
</script>
<style lang="scss">
$borderColor:#e1e1e1;
$unplanColor:#fe7678;
$planedColor:#58d2f9;
%clearfix{
    display:table; 
    clear:both;
    content:"";
}
.year_date_wrap{
    .month_item{
        float:left;
        width:25%;
        border-right: 1px solid $borderColor;
        border-bottom: 1px solid $borderColor;
        cursor:pointer;
        &:nth-of-type(4n){
            border-right:none;
        }
        &:nth-of-type(9){
            border-bottom-left-radius:4px;
        }
        &:nth-of-type(12){
            border-bottom-right-radius:4px;
        }
    }
    .month_name{
        padding:3px 0;
        text-align:center;
        font-size:16px;
        color:#333;
    }
    .week_header{
        &:after{
            @extend %clearfix;
        }
        .h_item{
            float:left;
            width:14.28%;
            padding:0 0 6px;
            text-align:center;
            font-size:12px;
            color:#999;
        }
    }
    .month_content{
        &:after{
            @extend %clearfix;
        }
    }
    .day_item{
        float:left;
        width:14.28%;
        padding:0 0 4px;
        text-align:center;
        font-size:12px;
    }
    .day_num{
        text-align:center;
        .day_tag{
            display:inline-block;
            width:22px;
            height:22px;
            line-height:22px;
            vertical-align:middle;
            color:#333;
            border-radius:22px;
            // &.planed{
                
            //     border:1px solid $planedColor;
            // }
            // &.unplaned{
            //     border-radius:22px;
            //     border:1px solid $unplanColor;
            // }
        }
        &.no_the_month{
            .day_tag{
                color:#cdcdcd;
            }
            
        }
    }
}
</style>	
